import { useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router";

const useAuth = () => {
  const token = localStorage.getItem("auth");
  const navigate = useNavigate();

  const logoutUser = () => {
    localStorage.clear();
    navigate("/login");
  };
  const { getRemainingTime } = useIdleTimer({
    timeout: 60 * 60 * 1000 * 8, // Set timeout for 8hours (in milliseconds)
    onIdle: logoutUser,
    debounce: 500,
  });

  const checkTokenExpiration = () => {
    if (token) {
      let decodedToken = jwt_decode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp < currentTime) {
        logoutUser();
      }
    }
  };

  useEffect(() => {
    if (token) {
      const remainingTime = getRemainingTime();
      if (remainingTime <= 0 && token) {
        logoutUser();
      }
    }
  }, [token]);

  return { checkTokenExpiration, getRemainingTime };
};

export default useAuth;
